goog.module('yext.a11y.a11yclick');
goog.module.declareLegacyNamespace();

(function(jQuery) {
  // Prevent running multiple times
  if (window['a11yclickEnabled']) {
    asyncThrow(new Error('a11yclick invoked multiple times'));
    return;
  }
  window['a11yclickEnabled'] = true;

  // IE <=11 and Firefox <=37 use "Spacebar" instead of " "
  // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values#Whitespace_keys
  const CLICK_KEYS = ['Enter', ' ', 'Spacebar'];

  const RAW_KEY_EVENT = 'keypress';
  const EVENT_NAMESPACE = 'a11yclick';
  const A11Y_KEY_EVENT = `${RAW_KEY_EVENT}.${EVENT_NAMESPACE}`;

  const EVENT_REGEX = /\bclick(\.[\w-]+)?\b/g;

  const PREVENT_DEFAULT_BLACKLIST = ['A', 'I', 'SPAN', 'DIV'];

  // Plugins that don't interact well with this module.
  const NAMESPACE_BLACKLIST = ['chosen'];

  const origOn = jQuery.fn.on;
  jQuery.fn.on = function(types, selector, data, fn) {
    try {
      if (hasClickType(types) && !isDocument(this) && !isWindow(this)) {
        types = addKeypress(types);
        // NOTE(amullings): arguments.length is not reliable here, so I'm
        // following jQuery's lead.
        if (data == null && fn == null) {
          selector = a11yWrap(selector);
        } else if (fn == null) {
          data = a11yWrap(data);
        } else {
          fn = a11yWrap(fn);
        }
      }
    } catch (error) {
      asyncThrow(error);
    }
    return origOn.call(this, types, selector, data, fn);
  };

  const origOff = jQuery.fn.off;
  jQuery.fn.off = function(types, selector, fn) {
    try {
      if (hasClickType(types)) {
        types = addKeypress(types);
      }
    } catch (error) {
      asyncThrow(error);
    }
    return origOff.call(this, types, selector, fn);
  };

  /**
   * @param {jQuery} el
   * @return {boolean}
   */
  function isDocument(el) {
    // NOTE(rbiswas): don't need to add a11y wrapping to document clicks
    return el && el.is(document);
  }

  /**
   * @param {jQuery} el
   * @return {boolean}
   */
  function isWindow(el) {
    // NOTE(rbiswas): don't need to add a11y wrapping to window clicks
    return el && jQuery(window).is(el);
  }

  /**
   * @param {string} eventTypes
   * @return {boolean}
   */
  function hasClickType(eventTypes) {
    resetRegex();
    if (!EVENT_REGEX.test(eventTypes)) {
      return false;
    }
    resetRegex();
    let match;
    while ((match = EVENT_REGEX.exec(eventTypes)) !== null) {
      if (match[1] == null) {
        continue;
      }
      const namespace = match[1].substring(1);
      if (NAMESPACE_BLACKLIST.includes(namespace)) {
        return false;
      }
    }
    return true;
  }

  /**
   * Adds a namespaced keypress handler for each click event type
   * @param {string} eventTypes
   * @return {string}
   */
  function addKeypress(eventTypes) {
    resetRegex();
    return eventTypes.replace(EVENT_REGEX, `$& ${A11Y_KEY_EVENT}$1`);
  }

  /**
   * @param {function()} fn
   * @return {function()}
   */
  function a11yWrap(fn) {
    if (fn === false) {
      fn = returnFalse;
    }
    if (typeof(fn) !== 'function') {
      return fn;
    }

    // Based on jQuery's implementation of one-time event handlers:
    // https://github.com/jquery/jquery/blob/899c56f6ada26821e8af12d9f35fa039100e838e/src/event.js#L83
    const origFn = fn;

    /**
     * @param {Event} event
     */
    fn = function(event) {
      try {
        const callHandler = handleKeypresses(event, origFn);
        if (!callHandler) {
          return;
        }
      } catch (error) {
        asyncThrow(error);
      }
      return origFn.apply(this, arguments);
    };
    copyFunctionGuid(origFn, fn);
    return fn;
  }

  /**
   * Determines how a keypress event should be handled, and makes necessary
   * adjustments to the event object.
   * @param {Event} event the event currently being handled
   * @param {function()} origFn the original event handler
   * @return {boolean} true if the registered event handler should be called
   */
  function handleKeypresses(event, origFn) {
    if (!isKeypressEvent(event)) {
      return true;
    }

    if (hasOwnKeypressHandler(event.delegateTarget, origFn)) {
      // NOTE(amullings): jQuery alphabetizes the namespaces here for some
      // reason, hence the .includes() instead of .startsWith().
      if (event.handleObj.namespace.includes(EVENT_NAMESPACE)) {
        // Make sure that events don't get handled twice
        return false;
      } else {
        return true;
      }
    }

    if (isIgnoredKeypress(event)) {
      // Just pretend nothing happened;
      return false;
    }

    if (isButton(event.target)) {
      // Using a keypress on a button will trigger click handlers, so no
      // need to handle this event.
      return false;
    }

    if (isTextInput(event.target)) {
      return false;
    }

    impersonateClick(event);
    // Prevent form submission in IE11/Edge for elements that probably
    // aren't form inputs
    if (PREVENT_DEFAULT_BLACKLIST.includes(event.target.tagName)) {
      event.preventDefault();
    }
    return true;
  }

  /**
   * @param {Event} event
   * @return {boolean}
   */
  function isKeypressEvent(event) {
    return event.type === RAW_KEY_EVENT;
  }

  /**
   * If the element has a keypress handler besides the one registered by this
   * module, we don't want to handle keypresses as clicks.
   * @param {Element} elem
   * @param {function()} fn the event handler registered by this module
   * @return {boolean} true if there is a plain keypress handler registered
   * with the given handler function
   */
  function hasOwnKeypressHandler(elem, fn) {
    const events = jQuery._data(elem, 'events') || {};
    const keypressEvents = events[RAW_KEY_EVENT];
    if (!keypressEvents) {
      // This shouldn't happen, but let's play it safe.
      return true;
    }
    for (let handler of keypressEvents) {
      // NOTE(amullings): jQuery alphabetizes the namespaces here for some
      // reason, hence the .includes() instead of .startsWith().
      if (!handler['namespace'].includes(EVENT_NAMESPACE)
          && handler['guid'] === fn['guid']) {
        return true;
      }
    }
    return false;
  }

  /**
   * @param {Event} event
   * @return {boolean} true if the key event should not be treated as a click
   */
  function isIgnoredKeypress(event) {
    return !CLICK_KEYS.includes(event.key);
  }

  /**
   * @param {Element} elem
   * @return {boolean}
   */
  function isButton(elem) {
    return elem.tagName === 'BUTTON';
  }

  /**
   * @param {Element} elem
   * @return {boolean}
   */
  function isTextInput(elem) {
    return ['INPUT', 'TEXTAREA'].includes(elem.tagName);
  }

  /**
   * @param {Element} event
   */
  function impersonateClick(event) {
    event.type = 'click';
  }

  /**
   * @param {function()} srcFn
   * @param {function()} dstFn
   */
  function copyFunctionGuid(srcFn, dstFn) {
    // jQuery.fn.off looks for matching GUIDs
    dstFn['guid'] = srcFn['guid'] || ( srcFn['guid'] = jQuery['guid']++ );
  }

  /**
   * @return {boolean}
   */
  function returnFalse() {
    return false;
  }

  /**
   * @param {Error} error
   */
  function asyncThrow(error) {
    window.setTimeout(() => {
      throw error;
    });
  }

  function resetRegex() {
    EVENT_REGEX.lastIndex = 0;
  }
})(jQuery);

